import { useEffect } from "react";

/**
 * Sets the document title and updates the meta description tag for the current route.
 * Called from a page component; runs on mount and whenever title/description change.
 */
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }
  }, [title, description]);
};

export default usePageMeta;
